import { useMatch, useParams } from 'react-router-dom';
import { useEffect, useState, useCallback } from 'react';
import IProduct from '../../entities/IProduct';
import {IMedia} from '../../entities/IMedia';
import ProductService from "../../services/ProductService";
import { rejects } from 'assert';
import ICategory from '../../entities/ICategory';
import MediaService from "../../services/MediaService";

export const useProductSubmitData = (productData: IProduct) => {
  const handleSubmit = useCallback(
    (productData: any) => {
      console.log(productData);
      if (productData.productId && productData.productId > 0) {
        return ProductService.updateProduct(productData.productId, productData);
      }
      return ProductService.createProduct(productData);
    },
    [],
  );

  return {
    handleSubmit,
    productData
  };
}

export const useMediaSubmitData = (mediaData: IMedia[]) => {
  const handleSubmit = useCallback(
    (mediaData: IMedia[]) => {
      console.log(mediaData);

      return MediaService.createMedias(mediaData);
    },
    [],
  );

  return {
    handleSubmit,
    mediaData
  };

}
